/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const ConfirmOldEmailChangeDataParser = 
/* #__PURE__ */ parsers.object([['code', codecString]]);
export class ConfirmOldEmailChangeData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return ConfirmOldEmailChangeDataParser.decode(input).map(res => new ConfirmOldEmailChangeData(res));
    }
    static unsafeDecode(input) {
        return ConfirmOldEmailChangeData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ConfirmOldEmailChangeDataParser.encode(data);
    }
    static schema() {
        return ConfirmOldEmailChangeDataParser.schema();
    }
}
